import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  currentOrg: null,
};

const organisationsSlice = createSlice({
  name: "organisations",
  initialState,
  reducers: {
    setCurrOrg(state, action) {
      state.currentOrg = action.payload;
    },
  },
});

export const { setCurrOrg } = organisationsSlice.actions;

export default organisationsSlice.reducer;
